// extracted by mini-css-extract-plugin
module.exports = {"xxxApp":"XxxApp_xxxApp__2JH4j"};